import { Directive, HostBinding, OnInit, input } from '@angular/core';

// Type for RGBA color string
export type RGBA = `rgba(${number}, ${number}, ${number}, ${number})`;

@Directive({
  selector: '[appPortalButton]',
})
export class PortalButtonDirective implements OnInit {
  color = input<'orange' | 'blue' | 'red'>('orange');
  disabled = input(false);

  @HostBinding('class') get hostClasses() {
    return [
      'size-full',
      'rounded-xl',
      'text-black',
      'shadow-lg',
      'drop-shadow-md',
      'transition-transform',
      this.disabled() ? '' : 'hover:scale-105',
      this.disabled() ? 'grayscale-100' : '',
      this.disabled() ? 'cursor-not-allowed' : 'cursor-pointer',
    ].join(' ');
  }

  @HostBinding('style') style: string = '';

  ngOnInit() {
    const gradient = this.getGradient();
    this.style = `
      background: ${gradient.stop2};
      background: radial-gradient(circle, ${gradient.stop1} 0%, ${gradient.stop2} 100%);
      box-shadow:
        -5px -5px 0px 0px rgba(0, 0, 0, 0.25) inset,
        0 3px 0 0 rgba(255, 255, 255, 0.25) inset;
    `;
  }

  getGradient(): { stop1: RGBA; stop2: RGBA } {
    switch (this.color()) {
      case 'blue':
        return {
          stop1: `rgba(234, 242, 254, 1)`,
          stop2: `rgba(101, 156, 248, 1)`,
        };
      case 'orange':
        return {
          stop1: `rgba(254, 213, 11, 1)`,
          stop2: `rgba(240, 116, 3, 1)`,
        };
      case 'red':
        return {
          stop1: `rgba(243, 173, 150, 1)`,
          stop2: `rgba(234, 65, 51, 1)`,
        };
      default:
        throw new Error(`Unsupported color: ${this.color()}`);
    }
  }
}
